import { getCurrentUser } from "aws-amplify/auth";

export interface Format {
  id: string;
  name: string;
  format: string;
  description?: string;
}

// 認証ヘッダーを取得するヘルパー関数
const getAuthHeaders = async (): Promise<Record<string, string>> => {
  try {
    await getCurrentUser();
    const { fetchAuthSession } = await import("aws-amplify/auth");
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();

    if (idToken) {
      return {
        "Content-Type": "application/json",
        Authorization: idToken,
      };
    }

    return {
      "Content-Type": "application/json",
    };
  } catch (error) {
    console.warn("認証トークンの取得に失敗しました:", error);
    return {
      "Content-Type": "application/json",
    };
  }
};

export const getFormats = async (): Promise<Format[]> => {
  try {
    console.log("フォーマット取得開始");
    const headers = await getAuthHeaders();
    console.log("認証ヘッダー:", headers);
    
    const response = await fetch(`/api/formats`, {
      method: "GET",
      headers: headers,
    });

    console.log("レスポンスステータス:", response.status);
    console.log("レスポンスOK:", response.ok);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("API エラー:", response.status, errorText);
      throw new Error("フォーマット情報の取得に失敗しました");
    }

    const result = await response.json();
    console.log("取得結果:", result);
    console.log("返却データ:", result.data || []);
    return result.data || [];
  } catch (error) {
    console.error("フォーマット情報の取得エラー:", error);
    throw error;
  }
}; 
